import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { productKeys } from './keys';

import type { TypeGetSkusSkuCodeResponse, TypeSkuDetailData } from '~/types/product.types';

/**
 * [상품관리] 상품 단건 상세 조회 API
 * @param skuCode 상품 코드
 */
export const fetchSkusSkuCode = async (skuCode: string): Promise<TypeSkuDetailData> => {
  const { data } = await axiosInstance.get<TypeGetSkusSkuCodeResponse>(
    `${API_ENDPOINT.PRODUCT.GET_SKUS_SKU_CODE}/${skuCode}`
  );
  return data.data;
};

type UseGetSkusSkuCodeQueryOptions = {
  skuCode: string;
  enabled?: boolean;
  silent?: boolean;
};

/**
 * [상품관리] 상품 단건 상세 조회 Query Hook
 * @description 상품등록/수정 상세보기, 출하코드 검색 모달에서 사용
 */
export const useGetSkusSkuCodeQuery = ({ skuCode, enabled = true, silent = false }: UseGetSkusSkuCodeQueryOptions) => {
  return useQuery({
    queryKey: productKeys.skuDetail(skuCode),
    queryFn: () => fetchSkusSkuCode(skuCode),
    enabled: enabled && !!skuCode,
    staleTime: 0,
    gcTime: 0,
    meta: silent ? { silent: true } : undefined,
  });
};
